export default {
  // Navigation
  nav: {
    home: 'Home',
    about: 'About Us',
    services: 'DI Services',
    products: 'DI Platform',
    computing: 'Computing Center',
    news: 'LinkNews',
    contact: 'Contact Us',
  },
  hero: {
    subTitle:
      'Building Next-Gen AI & Data Intelligence <br> Free Up Human Labor with Computing Power',
  },
  about: {
    title: 'About LinkWise',
    computingTitle: 'LinkWise',
    subTitle: 'Enterprise Data Intelligence Solutions Provider',
    description:
      'LinkWise specializes in enterprise data intelligence solutions, driven by the mission to “Free Up Human Resources With Computing Power.” With a globally oriented strategy, the company employs a containerized modular computing architecture to rapidly deploy high-performance intelligent computing centers worldwide.',

    description1:
      'Equipped with an end-to-end AI platform, LinkWise enables industry-tailored solutions and full-cycle data processing, helping clients accumulate core data assets and build sustainable competitive advantages. ',
    description2:
      'The company is focused on capturing local data resources and advancing AI applications across industrial scenarios.',
    description3:
      'Thomas Wang, Co-Founder and Chairman, holds a degree from Stanford University and is an accomplished scientist in AI, big data, and blockchain. He served as an early core scientist at Scale AI and contributed to graph science initiatives. He is also a member of the China Association of Scientists, ACM, and AAAI.',
    description4:
      'Sujun Wang, Co-Founder and President, earned his MBA from the University of Wales. He previously served as National Sales Director at Uni-President China, managing a 10,000-strong sales team generating billions in annual revenue. As General Manager of 2345.com’s Premier Alliance Department, he led the nation’s largest offline promotion team, achieving over ¥100 million in net profit annually. With over 15 years in offline operations and 10+ years in internet enterprise management, he possesses extensive expertise in large-scale team leadership and market expansion.',
    description5:
      'As a high-potential enterprise based in Shanghai Lingang, LinkWise has been certified as a “National Technology-Based SME” within its first year.',
    name1: 'Thomas Wang',
    name2: 'Sujun Wang',
  },
  partners: {
    title: 'Our Partners',
    computingTitle: 'Partners',
    subTitle:
      'Building the data intelligence ecosystem with global industry pioneers',
  },
  dataBusiness: {
    title: 'Data Intelligence Services',
    computingTitle: 'Data Intelligence',
    subTitle:
      'Comprehensive data intelligence services enabling enterprise intelligent transformation',
    btnText: '立即咨询',
    btnText1: '申请演示',
    tabList: {
      item1: 'Multimodal Data',
      item2: 'Agent',
      item3: 'Global Computing Power',
    },
    tab1: {
      title: 'Multi-Modal Data Solutions',
      subTitle:
        'LinkWise delivers data processing services for Al model training.',
      subTitle2:
        'Leveraging automated processing across all stages to maximize efficiency and precision.',
      modal: 'Modalities:',
      modalDesc: 'Images, Text, Audio/Video, Point Clouds and etc.',
      scene: 'Scenario:',
      sceneDesc: 'Finance, Healthcare, Transportation, Education and etc',
      childTabs: {
        item1: 'Point Cloud',
        item2: 'Semantic Segmentation',
        item3: 'Embodied Intelligence',
        item4: 'Supervised Fine-Tuning',
      },
      btnText: 'Learn More',
    },
    tab2: {
      title: 'Agent Development',
      subTitle:
        'Powered by data intelligence and LLM , we deliver industry-specific AI agents—from knowledge base construction to multimodal integration—enhancing operational efficiency and decision-making capabilities.',
      product: 'Solutions:',
      productDesc:
        'Finance Agent、Training Agent、Customer Service Agent and More',
      btnText: 'Book a Demo',
    },
    tab3: {
      title: 'Global Computing Power',
      subTitle:
        "LinkWise is building a worldwide computing power network, delivering globalized computing resource orchestration and management to meet enterprises' needs for AI training, inference, and cross-border data operations across multiple regions.",
      capability: 'Capabilities:',
      capabilityDesc:
        'Dedicated International Network、Global Data & Computing Power Mobility、Trusted Data Space',
      btnText: 'Learn More',
    },
  },
  dataPlatform: {
    title: 'Data Intelligence Platforms',
    computingTitle: 'Data Intelligence',
    subTitle:
      'The full-stack data intelligence platforms driving enterprise AI adoption',
    leftTitle: 'Data Intelligence Engine 5.0',
    leftDesc:
      'Efficient, Precise Multimodal Data Annotation & Asset Management System, Supports diverse data types: images, videos, audio, text, point clouds and etc, Fuels Global Al Training & Inference Pipelines',

    list: {
      item0: {
        title: 'Data Intelligence Engine 5.0',
        descr:
          'Efficient, Precise Multimodal Data Annotation & Asset Management System, Supports diverse data types: images, videos, audio, text, point clouds and etc, Fuels Global Al Training & Inference Pipelines',
      },
      item1: {
        title: 'Multi Model Storage 1.5',
        descr: ' All-in-One Al Model Fine-Tuning & Deployment Platform',
        child: {
          item1: '• Integrates 69 leading models for 39 application scenarios',
          item2:
            '• Significantly streamlines model selection & optimization workflows',
        },
      },
      item2: {
        title: 'iAgent 2.3',
        descr:
          'Low-Code Agent Development Environment, Build industry-specific AI applications & automation via drag-and-drop, Accelerates enterprise agile delivery',
      },
      item3: {
        title: 'HCRM 2.1',
        descr: ' Heterogeneous Computing Resource Management Platform',
        child: {
          item1: '• Dynamically manages global heterogeneous compute resources',
          item2:
            '• Powers mission-critical Al projects with robust infrastructure',
        },
      },
    },
  },
  computingCenter: {
    title: 'Computing Center',
    computingTitle: 'Computing Center',
    subTitle: 'Worldwide Computing Center Deployment Services',
    cityList: {
      item1: 'Abu Dhabi',
      item2: 'Tashkent',
      item3: 'Xinjiang, China',
      item4: 'Johor',
      item5: 'Hong Kong, China',
      item6: 'Tianjin, China',
      item7: 'Texas',
      item8: 'Mexico City',
    },
  },
  teuContainer: {
    title: 'Standard Container ',
    secondTitle: 'Modular Computing Power Solution',
    computingTitle: 'modular computing power',

    txtInfo: {
      title: 'LWCC-B200: Global Leading Prefabricated Computing Container',
      descr:
        'Engineered by LinkWise for high-density AI training — integrating supercomputing-grade hardware with hyper-efficient infrastructure',
    },

    list: {
      item1: {
        title: 'Elite Computing Performance',
        descr:
          'Each unit houses 16× NVIDIA Blackwell DGX B200 servers, delivering 576 petaFLOPS of sparse compute power per container',
      },
      item2: {
        title: 'Mod-Flex Deployment',
        descr:
          'Engineered for post-deployment disassembly and re-transport, our containerized solution delivers unmatched project adaptability',
      },
      item3: {
        title: 'Configurable by Design',
        descr:
          'Every module—compute, power, cooling—is custom-configured to meet regional requirements, ensuring seamless global deployment and compliance.',
      },
      item4: {
        title: 'High Efficiency & Reliability',
        descr:
          'Liquid + Air Dual-Mode (PUE≤1.15), 15+ min lithium backup & smart O/M platform ensure reliability.',
      },
    },
  },
  computingFacilities: {
    title: 'Redefining Next-Gen Infrastructure',
    computingTitle: 'Infrastructure',
    txtInfo: {
      title: 'LinkWise Modular',
      subTitle: 'AI Computing Center',
      descr:
        'Converging supercomputing infrastructure, renewable energy, and intelligent controls within standardized modules',
    },

    list: {
      item1: {
        title: 'Rapid Deployment',
        descr:
          "Powered by Linke Zhihua's modular computing containers, we deliver production in 6-8 weeks and on-site deployment in 2-3 days",
      },
      item2: {
        title: 'Sustainable Impact',
        descr:
          'Our green hydrogen ecosystem – powered by solar/wind energy – delivers 5,000+ annual carbon reduction while creating local jobs and community benefits.',
      },
      item3: {
        title: 'OmniSmart Control',
        descr:
          'Unified platform monitors compute, power, and cooling systems. Intelligent power unit manages generation, storage, and supply cycles.',
      },
      item4: {
        title: 'Global AI Frontier',
        descr:
          'Powered by LinkWise HCRM, we deliver seamless cross-border AI training, inference, and data services worldwide.',
      },
    },
  },
  news: {
    title: 'LinkNews',
  },
  linkWe: {
    title: 'Contact Us',
    subTitle: 'Partner with us to define the next era of data intelligence',
    rightTitle: 'Our consultant will call you soon.',
    computingTitle: 'consultant',
    formName: 'Name',
    formNamePlaceholder: 'Enter your name',
    formPhone: 'Phone',
    formPhonePlaceholder: 'Enter your phone number',
    formPosition: 'Company&Position',
    formPositionPlaceholder: 'Enter your company or position',
    formInterest: 'Interested Service ',
    formInterestPlaceholder: 'Please select',
    formMessage: 'Message',
    formMessagePlaceholder: 'Please enter the information you wish to know',
    btnText: 'Submit',
    txtPhone: 'Tel',
    txtEmail: 'Email',
    submitSuc: 'Submit Successfully',
    infoList: {
      item1: {
        title: 'Media&Government Partnerships',
        userName: 'Manager Hu',
        phone: '+86 15914210310',
        // email1: 'maxiaoxing@linkwise.tech',
      },
      item2: {
        title: 'Industry-Specific Solutions',

        userName: 'Manager zhou',
        phone: '+86 13810409176',

        // email1: 'yaozhiqing@linkwise.tech',
        // email2: 'zhoudongxia@linkwise.tech',
      },
      item3: {
        title: 'Data Intelligence Services',
        userName: 'Manager Geng',
        phone: '+86 13002187119',
        // email1: 'gengyao@linkwise.tech',
      },
    },
  },
  footer: {
    address:
      'Address：Building 9, St 1, Lin-gang Special Area, Shanghai, China‌   Headquarters Phone：021-60701336',
    copyright: 'Copyright © Shanghai LinkWise Data Intelligence Co., Ltd.',
    qrcode: 'Follow Us',
    qrcodeText: 'For More Information',
  },
};
